import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import Minus from "../../icons/minus.svg";
import Plus from "../../icons/plus.svg";
import { useAccordionContext } from "../Accordion/Accordion";
import { Icon } from "../Icon";
import styles from "./AccordionItem.module.scss";
export const AccordionItem = forwardRef(({ id, title, onClose, children }, ref) => {
    const { toggleAccordionItem, expandedIds, dispatchGTMEvent } = useAccordionContext();
    const innerElement = useRef(null);
    const [containerHeight, setContainerHeight] = useState(0);
    const isExpanded = useMemo(() => expandedIds.includes(id), [id, expandedIds]);
    const wasExpanded = useRef(isExpanded);
    useEffect(() => {
        if (isExpanded) {
            setContainerHeight(innerElement.current.offsetHeight);
        }
    }, []);
    useEffect(() => {
        // Only trigger when expanded state changes
        if (isExpanded !== wasExpanded.current) {
            if (!isExpanded) {
                // Before starting the transition for closing, set the height to the actual height of the inner content
                setContainerHeight(innerElement.current.offsetHeight);
                onClose?.();
            }
            // This timeout is needed to trigger the transition effect correctly
            setTimeout(() => {
                setContainerHeight(isExpanded ? innerElement.current.offsetHeight : 0);
            }, 0);
            wasExpanded.current = isExpanded;
        }
    }, [isExpanded, onClose]);
    const onExpandedAnimationEnd = () => {
        setContainerHeight(isExpanded ? "none" : 0);
    };
    const toggle = () => {
        if (isExpanded) {
            setContainerHeight(innerElement.current.offsetHeight);
        }
        toggleAccordionItem?.(id);
        dispatchGTMEvent?.(title);
    };
    const ariaControlLabel = `accordion-content-${id}`;
    return (_jsxs("div", { className: classNames(styles.container, { [styles.expanded]: isExpanded }), ref: ref, children: [_jsxs("button", { className: styles.titleSection, onClick: toggle, "data-testid": `accordion-title-${id}`, "aria-expanded": isExpanded ? "true" : "false", "aria-controls": ariaControlLabel, children: [_jsx("span", { className: styles.title, children: title }), _jsx(Icon, { component: isExpanded ? Minus : Plus })] }), _jsx("div", { id: ariaControlLabel, role: "region", "aria-labelledby": `accordion-title-${id}`, className: styles.content, style: { maxHeight: containerHeight }, onTransitionEnd: onExpandedAnimationEnd, children: _jsx("div", { className: styles.innerContent, ref: innerElement, "data-testid": `accordion-item-${id}`, children: children }) })] }));
});
//# sourceMappingURL=AccordionItem.js.map